import { FleekError } from './FleekError';

type SdkRequiredNodeRuntimeErrorOptions = Record<string, never>;

export class SdkRequiredNodeRuntimeError extends FleekError<SdkRequiredNodeRuntimeErrorOptions> {
  public name = 'SdkRequiredNodeRuntimeError';

  constructor() {
    super({});
  }

  toString = () => `The functionality of this SDK feature is dependent on the Node.js runtime.`;
}
